// @ts-ignore
// __webpack_public_path__ = '/'
import('./main')
export {}